/** @format */

import React, { Component } from 'react';
import intl from 'react-intl-universal';
import FileDownload from 'src/ui/library/FileDownload';
import { downloadPDFFile } from 'src/services/cms.service.js';
import serviceUrls from 'src/constants/serviceUrls';
// import { getPlatform } from 'src/helpers';
import iconTransform from 'src/helpers/iconTransform.js';

class FileDownloadControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: false,
    };
    this.onDownload = this.onDownload.bind(this);
  }

  onDownload = (setFileData, setStatus) => {
    // let deviceOS = getPlatform();
    //if (deviceOS === "Browser") {
    this.setState({ showSpinner: true });
    // }

    setStatus(true);
    const { downloadPDFDocument } = this.props;
    const goPDFId = downloadPDFDocument && downloadPDFDocument.goPDFId ? downloadPDFDocument.goPDFId : '';
    downloadPDFFile({ goPDFId }).then(res => {
      // success scenario
      if (res && res.success) {
        setFileData(res.pdfFileData, res.fileName);
        // if (deviceOS === "Browser") {
        this.setState({ showSpinner: false });
        //  }
      }

      // failure scenario
      if (!res || res.success === false) {
        //if (deviceOS === "Browser") {
        this.setState({ showSpinner: false });
        //}
        setStatus(false);
      }
    });
  };

  getPdfUrl = () => {
    const { downloadPDFDocument } = this.props;
    const token = sessionStorage.getItem('token');
    const userID = sessionStorage.getItem('userProfile');
    return `${serviceUrls.CMS_PDF_DOWNLOAD}?goPDFId=${
      downloadPDFDocument ? downloadPDFDocument.goPDFId : null
    }&token=${token}&userId=${userID}&cordova=1&cordovaaction=download&download=pdfFileData`;
  };

  render() {
    const { label, align, icon, downloadPDFDocument } = this.props;
    let deviceOS = 'Browser';
    let documentTypeString = 'contentparser.downloadPDF';
    if (downloadPDFDocument) {
      switch (downloadPDFDocument.fileExtensionName) {
        case 'xls':
        case 'xlsx':
          documentTypeString = 'contentparser.downloadExcel';
          break;
        case 'doc':
        case 'docx':
          documentTypeString = 'contentparser.downloadWord';
          break;
        default:
          documentTypeString = 'contentparser.downloadPDF';
          break;
      }
    }
    const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';

    return (
      <div className={`control-text flex-column ${alignClass}`}>
        {
          <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
            {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
            <div className={'control-icons-inline-controls'}>
              {deviceOS === 'Browser' ? (
                <FileDownload
                  label={label}
                  buttonLabel={intl.get(documentTypeString)}
                  onRequest={this.onDownload}
                  showSpinner={this.state.showSpinner}
                />
              ) : (
                // let pdfUrl = this.getPdfUrl();
                <FileDownload label={label} buttonLabel={intl.get(documentTypeString)} href={this.getPdfUrl()} showSpinner={false} />
              )}
            </div>
          </div>
        }
      </div>
    );
  }
}

export default FileDownloadControl;
